export default "__VITE_PUBLIC_ASSET__4a8253d7__"